import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AuthService } from '../services/auth.service';
import { EnvRoleService } from '../services/env-role.service';

/**
 * authGuard — two-stage access check:
 *
 * 1. Is the user authenticated at all?
 * 2. Does the user hold at least one IAG role valid for the DEPLOYED environment?
 *    (e.g. a PROD-only user hitting a NONPROD deployment is blocked here)
 *
 * Both failures redirect to /access-denied.
 */
export const authGuard: CanActivateFn = async (_route, _state) => {
  const authService    = inject(AuthService);
  const envRoleService = inject(EnvRoleService);
  const router         = inject(Router);

  if (!authService.isAuthenticated()) {
    await router.navigate(['/access-denied']);
    return false;
  }

  // Env-isolation check: user must have at least one role for the running env tier
  if (!envRoleService.hasEnvRoles()) {
    await router.navigate(['/access-denied']);
    return false;
  }

  return true;
};
